import { createUseStyles } from 'react-jss'
import style from './style'
import {
  TypographyElement,
  Paper
} from 'UI'

const useStyle = createUseStyles(style)

export default ({ objective }) => {
  const { paperClass } = useStyle()
  return (
    <Paper noHover className={paperClass}>
      <div>
        <TypographyElement
          variant='body1'
        >
          {objective}
        </TypographyElement>
      </div>
    </Paper>
  )
}
